import PaymentMethodScreen from './PaymentMethodScreen'
export default PaymentMethodScreen
